export const contentTableConfig = {
  title: '内容中心话术素材列表',
  propList: [
    {
      prop: 'title',
      label: '标题',
      minWidth: '80',
    },
    {
      prop: 'numOfClicks',
      label: '点击量',
      minWidth: '40',
      slotName: 'numOfClicks'
    },
    {
      prop: 'sort',
      label: '排序',
      width: '120',
    },
    {
      prop: 'updateTime',
      label: '更新时间',
      width: '220'
    },
    {
      label: '操作',
      width: '240',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
